import { preOrder } from '@/api/goods';
import { renderIntlLabel } from '@/utils';
import { ICartItem } from './type';

export enum stepEnumKey {
  first = 'CHOOSE',
  second = 'SETTLE',
}

export const titleTextMapKey = {
  CHOOSE: renderIntlLabel('goods_enum_stepEnumKey_CHOOSE'),
  SETTLE: renderIntlLabel('goods_enum_stepEnumKey_SETTLE'),
};

type ICalTotalRes = { totalNum: number; totalPrice: number };

type IFunctionCalTotal = (list: null | Map<string, ICartItem>) => ICalTotalRes;

// 购物车总数与总价计算
export const calTotalNumAndPrice: IFunctionCalTotal = (list) => {
  const none = { totalNum: 0, totalPrice: 0 };
  if (!list) return none;
  if (list.size === 0) return none;

  let totalNum = 0;
  let totalPrice = 0;
  list.forEach((value) => {
    totalPrice += Number(value.price) * value.cartNum;
    totalNum += value.cartNum;
  });

  return { totalNum, totalPrice };
};

// 预下单
export const preOrderHandle = async ($$: any, orderNoPre: string | null) => {
  const details = [];
  $$.cartList.forEach((goods: any) => {
    details.push({
      goodsPrice: goods.price,
      saleCount: goods.cartNum,
      skuCode: goods.skuCode,
    });
  });
  const { code, data: orderNo } = await preOrder({
    details,
    orderNo: orderNoPre,
    recNo: $$.recNo,
    resvNo: $$.resvNo,
    roomId: $$.roomId,
    roomNo: $$.roomNo,
    saleType: 0, // 0-房间消费 1-前台直售 （本处只有房间消费）
  });

  return { code, orderNo };
};

interface IGoodsStatus {
  label: string;
  value: '' | '1' | '2' | '3';
}

export const STATUS: IGoodsStatus[] = [
  { label: renderIntlLabel('goods_option_label_all'), value: '' },
  { label: renderIntlLabel('goods_option_label_food'), value: '2' },
  { label: renderIntlLabel('goods_option_label_drink'), value: '1' },
  { label: renderIntlLabel('goods_option_label_goods'), value: '3' },
];
